import { useNavigate } from 'react-router-dom';
import { useJobsSummary } from '../api/hooks';
import { JobRow } from './JobRow';
import { Btn, Empty, H2, Surface } from './ui';

/**
 * Přehled zakázek na úvodní obrazovce: co hoří (po termínu, dnes, čeká na zákazníka,
 * bez faktury, nevyzvednuté) – ať se na nic nezapomene.
 */
export function JobsPanel({ companyId, canWrite }: { companyId: string; canWrite: boolean }) {
  const navigate = useNavigate();
  const { data } = useJobsSummary(companyId);
  if (!data) return null;
  const c = data.counts;
  // firma, která zakázky nevede, panel nevidí
  if (!c.active && !c.ready && !data.attention.length) {
    return null;
  }
  const bits = [
    c.overdue ? `${c.overdue} po termínu` : '',
    c.dueToday ? `${c.dueToday} dnes` : '',
    c.ready ? `${c.ready} k vyzvednutí` : '',
  ].filter(Boolean);
  return (
    <section aria-label="Zakázky">
      <H2>
        Zakázky{' '}
        {data.attention.length ? <span className="cnt">{data.attention.length}</span> : null}
      </H2>
      <Surface>
        <div className="row">
          <div className="grow">
            <div className="l1">{c.active} rozpracovaných</div>
            <div className="l2">{bits.join(' · ') || 'vše v termínu'}</div>
          </div>
          <Btn sm onClick={() => navigate('/zakazky')}>
            Všechny
          </Btn>
          {canWrite && (
            <Btn sm variant="primary" onClick={() => navigate('/zakazky/nova')}>
              Nová
            </Btn>
          )}
        </div>
        {data.attention.slice(0, 6).map((job) => (
          <JobRow
            key={job.id}
            job={job}
            reason={job.reason}
            onClick={() => navigate(`/zakazky/${job.id}`)}
          />
        ))}
        {!data.attention.length && <Empty>Nic nehoří – všechny zakázky jsou v termínu.</Empty>}
      </Surface>
    </section>
  );
}
